import React, { useState } from 'react';
import Button from '../../../../shared/ui/button/Button';
import { fetchImageProject, generateImage } from '../../../../shared/api/imageProjectApi';
import { useAppDispatch } from '../../../../store/store';
import { toast } from 'react-toastify';

import { useSelector } from 'react-redux';
import { addImagesToLayout, deleteImageFromLayout } from '../../../../shared/api/imageLayoutApi';
import { generateContent, updateProject } from '../../../../shared/api/textProjectApi';
import IconStars from '../../../../shared/ui/icons/IconStars';
import {
    selectGenerationMode,
    selectSelectedSocialMedia,
} from '../../../../store/selectors/projectSelectors';
import { useLocation } from 'react-router-dom';
import {
    selectImageGenerated,
    selectIsFreeSubscription,
    selectIsBasicSubscription,
    selectPlan,
    selectPostsUsed,
    selectUserSubscription,
} from '../../../../store/selectors/subscriptionSelector';
import IconLock from '../../../../shared/ui/icons/IconLock';
import { setPricingModal } from '../../../../store/slices/pageSlice';
import { updateUserSubscription } from '../../../../store/slices/subscriptionSlice';
import { setSelectedImage } from '../../../../store/slices/imageSlice';

type GenerateButtonProps = {
    currentProject: any;
    activeEditorMode: string;
    prompt: string;
    imageProject: any;
    selectedImage: any;
    saveImage: () => Promise<void>;
};
const GenerateButton = ({
    activeEditorMode,
    currentProject,
    selectedImage,
    prompt,
    imageProject,
    saveImage,
}: GenerateButtonProps) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const selectedSocialMedia = useSelector(selectSelectedSocialMedia);
    const generationMode = useSelector(selectGenerationMode);
    const isFreeSubscription = useSelector(selectIsFreeSubscription);
    const isBasicSubscription = useSelector(selectIsBasicSubscription);
    const userSubscription = useSelector(selectUserSubscription);
    const imageGenerated = useSelector(selectImageGenerated);

    const isRestrictGenerateFreeUser = isFreeSubscription;

    const isRestrictImageGenerateBasicUser = imageGenerated > 45 && isBasicSubscription;

    const handleGenerateScript = async () => {
        if (!prompt || prompt.trim() === '') {
            toast.error('Please enter a prompt first');
            setLoading(false);
            return;
        }

        if (currentProject?.id) {
            console.log('generationMode', generationMode);
            try {
                const newData = {
                    ...currentProject,
                    prompt: prompt,
                    content_type: selectedSocialMedia || currentProject?.content_type,
                };
                await dispatch(updateProject(newData));
                const response = await dispatch(
                    generateContent({
                        projectId: currentProject.id,
                        kind: generationMode || 'text_only',
                    }),
                ).unwrap();
                if (response.imageData?.id) {
                    await dispatch(fetchImageProject(response.imageData.id)).unwrap();
                }
                console.log('Script generated successfully:', response);
            } catch (error: any) {
                toast.error(error?.message || 'Failed to handle generate script');
                console.error('Failed to handle generate script:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleGenerateImage = async () => {
        console.log(prompt, 'prompt');
        if (!prompt || prompt.trim() === '') {
            toast.error('Please enter a prompt first');
            return;
        }

        setLoading(true);
        if (!imageProject?.layouts?.length) return;

        try {
            const generated = await dispatch(
                generateImage({
                    prompt,
                    creativity_level: 1,
                    is_realism_mode: false,
                }),
            ).unwrap();
            dispatch(
                updateUserSubscription({
                    ...userSubscription,
                    image_generations_used: (userSubscription?.image_generations_used ?? 0) + 1,
                    remaining_images: (userSubscription?.image_generations_quota ?? 0) - 1,
                }),
            );

            const layoutId = imageProject.layouts[0].id;

            if (selectedImage?.image != null) {
                await dispatch(
                    deleteImageFromLayout({
                        layoutId: layoutId!,
                        imageId: selectedImage.image.id,
                    }),
                ).unwrap();

                await dispatch(
                    addImagesToLayout({
                        layoutId: layoutId!,
                        images: [{ id: generated.id, order: 1 }],
                    }),
                ).unwrap();
                await dispatch(setSelectedImage({ image: generated, layoutId: layoutId }));
                setTimeout(async () => {
                    await saveImage();
                }, 2000);
                return;
            }
            console.log('generated', generated);
            console.log(layoutId, 'layoutId');

            if (layoutId && generated?.id) {
                console.log(layoutId, 'layoutId');
                await dispatch(
                    addImagesToLayout({
                        layoutId,
                        images: [{ id: generated.id, order: 1 }],
                    }),
                ).unwrap();
                await dispatch(setSelectedImage({ image: generated, layoutId: layoutId }));
                setTimeout(async () => {
                    await saveImage();
                }, 2000);
            }

            toast.success('Image generated successfully');
        } catch (error: any) {
            toast.error(error?.message || 'Error generating image');
            console.error('Error generating image:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleGenerate = () => {
        if (isRestrictGenerateFreeUser || isRestrictImageGenerateBasicUser) {
            dispatch(setPricingModal(true));
            return;
        }
        console.log(location.pathname, 'location.pathname');
        if (location.pathname.includes('create-post')) {
            console.log(generationMode, 'generationMode');
            if (generationMode === 'text_image') {
                console.log('text_and_image');
                handleGenerateScript();
            }
            if (generationMode === 'text_only') {
                console.log('text_only');
                handleGenerateScript();
            }
            if (generationMode === 'image_only') {
                console.log('image_only');
                handleGenerateImage();
            }
        }

        if (location.pathname.includes('custom-post')) {
            if (activeEditorMode === 'Visual') {
                handleGenerateImage();
            }
            if (activeEditorMode === 'Captions') {
                handleGenerateScript();
            }
        }
    };
    return (
        <Button
            text="Generate"
            onClick={handleGenerate}
            icon={
                isRestrictGenerateFreeUser || isRestrictImageGenerateBasicUser ? (
                    <IconLock color="white" />
                ) : (
                    <IconStars color="white" />
                )
            }
            iconPosition="left"
            style={{
                width: '150px',
                height: '35px',
                background: 'linear-gradient(90deg, #8801FF 0%, #D400FF 100%)',
                color: 'white',
            }}
            state={loading ? 'loading' : !prompt || prompt.trim() === '' ? 'disabled' : 'enabled'}
        />
    );
};

export default GenerateButton;
